import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class DashboardService {

  constructor(
    private http: HttpClient
  ) { }

  listCandidateByStage(id: any, jobId: any) {
    return this.http.get(`${environment.baseUrl}/candidate/v1/get-candidatestage/${id}/?filterValue=1&jobId=${jobId}`);
  }

  listUser() {
    return this.http.get(`${environment.baseUrl}/user/v1/get-user/?skip=-1&filterValue=1`);
  }

  GetClient() {
    return this.http.get(`${environment.baseUrl}/client/v1/get-client/?skip=-1&filterValue=1`);
  }

  GetProject() {
    return this.http.get(`${environment.baseUrl}/project/v1/get-project/?skip=-1&filterValue=1`);
  }

  listRole(searchValue, skip, limit, filterValue) {
    return this.http.get(`${environment.baseUrl}/role/v1/get-role/?searchValue=${searchValue}&limit=${limit}&skip=${skip}&filterValue=${filterValue}`);
  }

  listDepartment() {
    return this.http.get(`${environment.baseUrl}/department/v1/get-department/?filterValue=1`);
  }

  listDesignation(searchValue, skip, limit, filterValue) {
    return this.http.get(`${environment.baseUrl}/designation/v1/get-designation/?searchValue=${searchValue}&limit=${limit}&skip=${skip}&filterValue=${filterValue}`);
  }

  listTechnology(searchValue, skip, limit, filterValue) {
    return this.http.get(`${environment.baseUrl}/technology/v1/get-technology/?searchValue=${searchValue}&limit=${limit}&skip=${skip}&filterValue=${filterValue}`);
  }

  listJob() {
    return this.http.get(`${environment.baseUrl}/job/v1/get-job/?skip=-1&filterValue=1`);
  }

  countUserByRole() {
    return this.http.get(`${environment.baseUrl}/user/v1/get-user-role`);
  }

  PrOverview() {
    return this.http.get(`${environment.baseUrl}/dashboard/v1/ticket`);
  }

  validateUser() {
    return this.http.get(`${environment.baseUrl}/user/v1/validate`);
  }
}
